export default function PoweredByBanner({ provider, position = 'right' }) {
  return (
    <div
      className={`absolute top-4 ${position === 'left' ? 'left-0' : 'right-0'}`}
      style={{
        filter: 'drop-shadow(-3px -3px 4px rgba(0,0,0,0.15))',
        right: position === 'left' ? 'auto' : '-6px',
      }}
    >
      <div
        className="flex items-center gap-1.5 bg-[#F4A7CC] pl-8 pr-4 py-1.5"
        style={{
          clipPath: 'polygon(12px 0%, 100% 0%, 100% 100%, 12px 100%, 24px 50%)',
          borderRadius: '0 0 5px 0',
        }}
      >
        <span
          className="font-normal"
          style={{
            color: '#1F1F1F',
            fontFamily: 'Minion Pro',
            fontSize: '12px',
            lineHeight: '18px',
            letterSpacing: '0%',
          }}
        >
          Powered by
        </span>
        <img
          src={provider === 'YabanPay' ? '/assets/images/payment-logos/yabandpay.svg' : provider === 'BTSE' ? '/assets/images/payment-logos/btse.svg' : '/assets/images/payment-logos/strip.svg'}
          alt={provider}
          className="h-5 w-auto"
        />
      </div>
      {/* Top-right triangle 3D effect */}
      <div
        style={{
          width: 0,
          height: 0,
          borderRight: '6px solid transparent',
          borderBottom: '6px solid #731748',
          position: 'absolute',
          top: '-6px',
          right: '0',
        }}
      />
    </div>
  );
}